import { useNavigate} from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Spinner from "../../Utils/spinner/loading";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useUploadVesselImages } from "../utils/useUploadVesselImages";
import { HiX, HiArrowLeft } from "react-icons/hi";
import { ReactComponent as VatugIcon } from "../../Asset/black.svg";
import "../create_vessels/createvessel.css";

const VesselImages = () => {
  const navigate = useNavigate();
  const { mutate, isLoading, error: mutationError } = useUploadVesselImages();
  const [images, setImages] = useState([]);
  const [previewURLs, setPreviewURLs] = useState([]);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (mutationError) {
      toast.error(mutationError.message || "An error occurred during image upload. Please try again.");
    }
  }, [mutationError]);

  const handleChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (images.length + selectedFiles.length > 5) {
      toast.error("You can upload a maximum of 5 images.");
      return;
    }
    const updatedImages = [...images, ...selectedFiles];
    setImages(updatedImages);
    const newPreviewURLs = selectedFiles.map(file => URL.createObjectURL(file));
    setPreviewURLs(prev => [...prev, ...newPreviewURLs]);
  };

  const handleRemoveImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    const newPreviewURLs = previewURLs.filter((_, i) => i !== index);
    setImages(newImages);
    setPreviewURLs(newPreviewURLs);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (images.length < 3) {
      toast.error("You must upload at least 3 images before proceeding.");
      return;
    }

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    mutate(formData, {
      onError: (err) => {
        console.error(err);
      },
      onSuccess: () => {
        toast.success("Images uploaded successfully!");
      }
    });
  };

  const handleImageClick = () => {
    if (images.length >= 5) {
      toast.error("You can upload a maximum of 5 images.");
      return;
    }
    fileInputRef.current.click();
  };

  return (
    <div className="create-vessel-container">
      <div className="create-vessel-header-bar">
        <div className="logo-container">
          <VatugIcon />
          <div className="logo-underline"></div>
        </div>
        <div className="title">Vessel Upload</div>
        <button className="close-btn" onClick={() => navigate("/dashboard/myvessels")}><HiX /></button>
      </div>

      <div className="create-image-card">
        <h2>Image Upload</h2>
        <div className="upload-area" onClick={handleImageClick}>
          {/* <div className="upload-placeholder">
            <img src="https://i.ibb.co/L86CYRV/Frame-1171275956.png" alt="Upload" />
            <p>Drop an image here,</p>
            <p className="browse-text">or browse</p>
          </div> */}
          <p className="supported-formats">Supports: JPG, JPE, PNG</p>
        </div>

        <input
          type="file"
          multiple
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleChange}
          accept="image/*"
        />

        <div className="preview-grid">
          {previewURLs.map((url, index) => (
            <div key={index} className="preview-item">
              <img src={url} alt={`Preview ${index + 1}`} />
              <button 
                className="remove-preview" 
                onClick={() => handleRemoveImage(index)}
              >
                <HiX />
              </button>
            </div>
          ))}
          {[...Array(Math.max(0, 5 - previewURLs.length))].map((_, index) => (
            <div 
              key={`empty-${index}`} 
              className="preview-placeholder"
              onClick={handleImageClick}
            >
              <span>+</span>
            </div>
          ))}
        </div>

        <div className="button-row">
          <button className="back-btn" onClick={() => navigate("/vessel_general_information")}>
            <HiArrowLeft style={{marginRight: 6}}/> Go Back
          </button>
          <button 
            className="next-btn" 
            onClick={handleSubmit}
            disabled={isLoading || images.length < 3}
          >
            {isLoading ? <Spinner /> : "Next"}
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VesselImages;
